module.exports = __webpack_public_path__ + "img/logo.c323c029.png";